import axios from "@/plugins/axios";

export const fetchBrandList = async (vehicleType) => {
  try {
    const response = await axios.get(`/prices/brand-list`, {
      params: { vehiculeType: vehicleType },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener lista de marcas:", error);
    throw error;
  }
};


export const fetchAllBrands = async () => {
  try {
    const response = await axios.get(`/prices/all-brands`);
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener todas las marcas:", error);
    throw error;
  }
};

export const fetchBrandsByVehiculeType = async (vehicleType) => {
  try {
    const response = await axios.get(`/prices/brands-by-vehicule-type`, {
      params: { vehiculeType: vehicleType },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener marcas por tipo de vehículo:", error);
    throw error;
  }
};


// ABM Marcas

export const fetchVehiculeBrands = async (params) => {
  try {
    const response = await axios.get("/vehicule-brands", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicule brands:", error);
    throw error;
  }
};

export const createVehiculeBrand = async (formData) => {
  try {
    const response = await axios.post("/vehicule-brands", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating vehicule brand:", error);
    throw error;
  }
};

export const updateVehiculeBrand = async (id, formData) => {
  try {
    const response = await axios.post(`/vehicule-brands/${id}?_method=PUT`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating vehicule brand:", error);
    throw error;
  }
};

export const deleteVehiculeBrand = async (id) => {
  try {
    const response = await axios.delete(`/vehicule-brands/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting vehicule brand:", error);
    throw error;
  }
};
